import * as list from './list';

const reducers = {
  ...list,
};

export default reducers;
